export const onDownloadContentFile = (e, href: string, download: string) => {
  e.preventDefault();

  const link = document.createElement('a');
  link.href = href;
  link.download = download;
  link.click();
}
